export const api = "https://phong-tro-vn.herokuapp.com/nguoi-dung";

export const apiWithoutUser = "https://phong-tro-vn.herokuapp.com/";

export const chatAPI = "http://192.168.0.130:5000/";